import { Contenido } from './Contenido';

export class Informe {
	// Un Informe es un contenido a mostrar en la pantalla de Informes
	Contenido: Contenido;
	
	Id: string;
	Elemento: string;
	Descripcion: string;
	Tipologias: string;
	PermaneceDesde: string;
	Seccion: string;
	X: number;
	Y: number;

	// Campos para selector dropdown
	value: string;
	label: string;  
	// ENTIDAD: any;

	constructor(){
		this.Id = '';
		this.Elemento = '';
		this.Descripcion = '';
		this.Tipologias = '';
		this.PermaneceDesde = '';
		this.Seccion = '';
	}


	fromContenido(cont: Contenido): Informe{
		this.Contenido = cont;

		this.Id = this.Contenido.Id;
		this.Elemento = this.Contenido.Titulo;
		this.Descripcion = this.Contenido.Descripcion;
		this.Tipologias = this.Contenido.Tipo;
		this.PermaneceDesde = 'TODO: ';
		this.Seccion = this.Contenido.Seccion;
		this.X = this.Contenido.X;
		this.Y = this.Contenido.Y;

		this.value = this.Contenido.Id;
		this.label = this.Contenido.Titulo;  

		return this;
	}

	fromENTIDAD(ENTIDAD: any): Informe{
		this.Contenido = new Contenido().fromENTIDAD(ENTIDAD);

		this.Id = this.Contenido.Id;
		this.Elemento = this.Contenido.Titulo;
		this.Descripcion = this.Contenido.Descripcion;
		this.Tipologias = this.Contenido.Tipo;
		this.PermaneceDesde = 'TODO: ';
		this.Seccion = this.Contenido.Seccion;
		this.X = this.Contenido.X;
		this.Y = this.Contenido.Y;

		return this;
	}


}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/domain/Informe.ts